"use client";

import * as React from 'react';
import clsx from 'clsx';
import { useBootstrapPrefix } from './ThemeProvider.js';
import { jsx as _jsx } from "react/jsx-runtime";
const TabContent = /*#__PURE__*/React.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'tab-content');
  return /*#__PURE__*/_jsx(Component, {
    ref: ref,
    className: clsx(className, bsPrefix),
    ...props
  });
});
TabContent.displayName = 'TabContent';
export default TabContent;